import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCatalogProductsSearchLayeredPricesResponse, transformCatalogProductsSearchLayeredResponse, transformCatalogProductsSearchSortablesResponse, transformCatalogProductsSuggestsResponse, transformCatalogProductsSearchResponse, transformCatalogProductsSearchRecommendationFullResponse } from './transformers.js';
import { getBaseLayered, getActiveFiltersByWhere, getPromisesLayered, getActiveFiltersLayered, getFinalLayered } from '../../utils/layered.js';
import defaultClient from 'axios';

const postCatalogProductsMetricsCollect = async ({ client , controller , event , eventName , itemIds , extItemIds , positions , searchId , userId , userIsLoggedIn , revenue , tax , shipping  } = {})=>await client.post(`V1/catalog/products/metrics/collect`, {
        event: event,
        event_name: eventName,
        item_ids: itemIds,
        extItem_ids: extItemIds,
        positions: positions,
        search_id: searchId,
        user_id: userId,
        user_isloggedin: userIsLoggedIn,
        revenue,
        tax,
        shipping
    }, {
        signal: controller?.signal
    });
postCatalogProductsMetricsCollect.key = 'postCatalogProductsMetricsCollect';
const getCatalogProductsSearchCount = async ({ client , controller , searchTerm , where ={}  } = {})=>await client.get(`V1/catalog/products/search/count/${encodeURIComponent(searchTerm)}`, {
        signal: controller?.signal,
        params: {
            where
        }
    });
getCatalogProductsSearchCount.key = 'getCatalogProductsSearchCount';
const getCatalogProductsSearchLayeredPrices = async ({ client , controller , searchTerm , where ={}  } = {})=>await client.get(`V1/catalog/products/search/layered/prices/${encodeURIComponent(searchTerm)}`, {
        signal: controller?.signal,
        params: {
            where
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsSearchLayeredPricesResponse)
        ]
    });
getCatalogProductsSearchLayeredPrices.key = 'getCatalogProductsSearchLayeredPrices';
const getCatalogProductsSearchLayered = async ({ client , controller , searchTerm , where ={}  } = {})=>await client.get(`V1/catalog/products/search/layered/${encodeURIComponent(searchTerm)}`, {
        signal: controller?.signal,
        params: {
            where
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsSearchLayeredResponse)
        ]
    });
getCatalogProductsSearchLayered.key = 'getCatalogProductsSearchLayered';
const getCatalogProductsSearchSortables = async ({ client , controller , searchTerm , where ={}  } = {})=>await client.get(`V1/catalog/products/search/sortables/${encodeURIComponent(searchTerm)}`, {
        signal: controller?.signal,
        params: {
            where
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsSearchSortablesResponse)
        ]
    });
getCatalogProductsSearchSortables.key = 'getCatalogProductsSearchSortables';
const getCatalogProductsSuggests = async ({ client , controller , searchTerm  } = {})=>await client.get(`V1/catalog/products/suggests/${encodeURIComponent(searchTerm)}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsSuggestsResponse)
        ]
    });
getCatalogProductsSuggests.key = 'getCatalogProductsSuggests';
const getCatalogProductsSearch = async ({ client , controller , searchTerm , fields ={} , where ={} , order =[] , limit =1000000 , offset =0 , skip  } = {})=>await client.get(`V1/catalog/products/search/${encodeURIComponent(searchTerm)}`, {
        signal: controller?.signal,
        params: {
            filter: {
                fields,
                where,
                order,
                limit,
                offset,
                skip
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsSearchResponse)
        ]
    });
getCatalogProductsSearch.key = 'getCatalogProductsSearch';
const getCatalogProductsSearchRecommendationFull = async ({ client , controller , searchTerm , fields ={} , where ={} , order =[] , limit =1000000 , offset =0 , skip =0  } = {})=>await client.get(`V1/catalog/products/search/recommendation/full/${encodeURIComponent(searchTerm)}`, {
        signal: controller?.signal,
        params: {
            filter: {
                fields,
                where,
                order,
                limit,
                offset,
                skip
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogProductsSearchRecommendationFullResponse)
        ]
    });
getCatalogProductsSearchRecommendationFull.key = 'getCatalogProductsSearchRecommendationFull';
const getSearchProductsLayeredAttributes = async ({ client , controller , searchTerm , where  })=>{
    const baseLayered = await getBaseLayered({
        client,
        controller,
        searchTerm,
        where,
        attributesMethod: getCatalogProductsSearchLayered,
        pricesMethod: getCatalogProductsSearchLayeredPrices
    });
    // calculate key of active filters
    const activeFilters = getActiveFiltersByWhere(where);
    const promisesLayered = getPromisesLayered({
        activeFilters,
        baseLayered,
        client,
        controller,
        searchTerm,
        where,
        attributesMethod: getCatalogProductsSearchLayered,
        pricesMethod: getCatalogProductsSearchLayeredPrices
    });
    // exec all promises for active filters
    const activeFiltersLayered = await getActiveFiltersLayered(promisesLayered);
    return {
        data: getFinalLayered({
            baseLayered,
            activeFiltersLayered,
            promisesLayered
        })
    };
};
getSearchProductsLayeredAttributes.key = 'getSearchProductsLayeredAttributes';
const getSearchProductsRedirect = async ({ client , controller , searchTerm , where ={}  } = {})=>await client.get(`V1/catalog/products/search/config/${encodeURIComponent(searchTerm)}`, {
        signal: controller?.signal,
        params: {
            where
        }
    });
getSearchProductsRedirect.key = 'getSearchProductsRedirect';

export { getCatalogProductsSearch, getCatalogProductsSearchCount, getCatalogProductsSearchLayered, getCatalogProductsSearchLayeredPrices, getCatalogProductsSearchRecommendationFull, getCatalogProductsSearchSortables, getCatalogProductsSuggests, getSearchProductsLayeredAttributes, getSearchProductsRedirect, postCatalogProductsMetricsCollect };
